import { z } from 'zod';

import { CatalogDefaultAccountKeySchema } from '../products/product.schemas.js';

import { ServicePricingBodySchema } from './service-pricing.schemas.js';

export const UpdateServiceBodySchema = z
  .object({
    name: z.string().trim().min(1).max(255).optional(),
    categoryId: z.uuid().nullable().optional(),
    serviceTypeId: z.uuid().nullable().optional(),
    isThirdParty: z.boolean().optional(),
    usefulLifeMonths: z.number().int().nonnegative().nullable().optional(),
    usefulLifeMeters: z.number().int().nonnegative().nullable().optional(),
    alertMonths: z.number().int().nonnegative().nullable().optional(),
    alertMeters: z.number().int().nonnegative().nullable().optional(),
    code: z.string().trim().max(50).nullable().optional(),
    description: z.string().trim().max(5000).nullable().optional(),
    estimatedDurationMinutes: z.number().int().positive().nullable().optional(),
    warrantyMonths: z.number().int().nonnegative().nullable().optional(),
    warrantyMeters: z.number().int().nonnegative().nullable().optional(),
    pricing: ServicePricingBodySchema.optional(),
    defaultRevenueAccountKey: CatalogDefaultAccountKeySchema.nullable().optional(),
    defaultCostAccountKey: CatalogDefaultAccountKeySchema.nullable().optional(),
    commissionRateBps: z.number().nullable().optional(),
  })
  .refine((body) => Object.keys(body).length > 0, { message: 'At least one field is required' });

export const UpdateServiceResponseSchema = z.object({
  serviceId: z.uuid(),
  changedFields: z.array(z.string()),
});

export type UpdateServiceBody = z.infer<typeof UpdateServiceBodySchema>;
export type UpdateServiceResponse = z.infer<typeof UpdateServiceResponseSchema>;
